import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHero = ({ overline, title, description, crumb, parentCrumb }) => {
  return (
    <section className="relative overflow-hidden bg-navy pt-36 pb-20 lg:pt-44 lg:pb-24">
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
        backgroundImage:
          "radial-gradient(circle at 20% 20%, #D98A2C 0, transparent 40%), radial-gradient(circle at 80% 0%, #ffffff 0, transparent 35%)",
      }} />
      <div className="absolute -right-24 top-10 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <nav className="mb-6 flex items-center gap-2 text-sm text-white/50" data-testid="breadcrumb">
          <Link to="/" className="hover:text-gold transition-colors">Home</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          {parentCrumb && (
            <>
              <Link to={parentCrumb.to} className="hover:text-gold transition-colors" data-testid="breadcrumb-parent">{parentCrumb.label}</Link>
              <ChevronRight className="h-3.5 w-3.5" />
            </>
          )}
          <span className="text-white/80">{crumb || title}</span>
        </nav>
        {overline && <span className="overline text-xs text-gold-light">{overline}</span>}
        <h1 className="mt-4 max-w-4xl font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tight text-white">
          {title}
        </h1>
        {description && (
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/75">{description}</p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
